import ClusterIcon from './component'

export default ClusterIcon
